import React from "react";

export default function CartSpecialOfferDisplay({offer, handleRemoveCoupon}) {

  return <div className="p-2">
    <div className="bg-gray-100 lg:w-1/2">
      <div className="text-left">
        <span className="far fa-ticket mx-2 text-brand-dark text-lg align-middle" />
        <span className="align-middle">Coupon applied to your cart:</span>
      </div>
      <div className="text-center py-2">
        <strong>{offer.name}</strong>
        <div>{offer.description}</div>
      </div>

      <div className="text-right py-1">
        <a className="cursor-pointer underline text-pencil hover:text-black text-sm"
          onClick={handleRemoveCoupon}>
          <span className="fa fa-times mx-1"/>
          remove coupon
        </a>
      </div>
    </div>

  </div>
}
